module.exports = __webpack_public_path__ + "img/Icons for SPIM Sidebar-57.f027c1b7.svg";